import { useQuery } from '@tanstack/react-query'
import useAuth from '@/features/auth/hooks/use-auth'
import { staffSessionV2Service } from '@/features/auth/staff-session-v2.service'

/** Clave única del perfil self-service v2; las mutaciones la invalidan tras cambiar datos. */
export const staffProfileQueryKey = ['staff', 'me', 'profile'] as const

/**
 * Lee el perfil staff (usuario, correo, nombre) desde `GET /api/v2/me/profile`,
 * reemplazando las tres lecturas v1 sueltas (`get-email`, `get-username`, `me`).
 */
export function useStaffProfileQuery() {
  const { auth } = useAuth()
  const accessToken = auth?.v2AccessToken

  return useQuery({
    queryKey: staffProfileQueryKey,
    queryFn: () => {
      if (!accessToken) throw new Error('Missing v2 access token')
      return staffSessionV2Service.getProfile(accessToken)
    },
    enabled: Boolean(accessToken),
    refetchOnWindowFocus: false
  })
}
